export const LOGOUT = 'LOGOUT';

export const VALUE_OF_ONE_STAR_IN_USD = 0.02;
export const STARS_FOR_ONE_USD = 1 / VALUE_OF_ONE_STAR_IN_USD;

export const VERIFICATION_CODE_TYPES = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
};

export const INFLUENCER_REQUEST_STATUS = {
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  PASSWORD_CREATED: 'PASSWORD_CREATED',
  REVIEW_IN_PROGRESS: 'REVIEW_IN_PROGRESS',
  REVIEW_ACCEPTED: 'REVIEW_ACCEPTED',
  REVIEW_REJECTED: 'REVIEW_REJECTED',
  ID_DOCUMENT_VERIFIED: 'ID_DOCUMENT_VERIFIED',
  TELEGRAM_INFO_CREATED: 'TELEGRAM_INFO_CREATED',
  MEDIA_PRICE_SET: 'MEDIA_PRICE_SET',
  MEDIA_UPLOADED: 'MEDIA_UPLOADED',
  VOICE_UPLOADED: 'VOICE_UPLOADED',
  PERSONALITY_CREATED: 'PERSONALITY_CREATED',
  APPROVAL_IN_PROGRESS: 'APPROVAL_IN_PROGRESS',
  WRITING_STYLE_CREATED: 'WRITING_STYLE_CREATED',
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
};

export const PAYMENT_SESSION_STATUS = {
  CREATED: 'CREATED',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED',
};

export const UPLOAD_FILE_CONSTRAINTS = {
  TYPE: {
    PHOTO: 'PHOTO',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    MIXED: 'MIXED',
    STORY: 'STORY',
  },
  PHOTO: {
    MAX_SIZE_IN_BYTES: 10 * 1024 * 1024, // 10 MB
    MAX_SIZE_IN_MB: 10,
    ALLOWED_EXTENSIONS: ['png', 'jpeg', 'jpg', 'heic'],
    ALLOWED_EXTENSIONS_TEXT: '.png, .jpeg, .jpg, .heic',
  },
  AUDIO: {
    MAX_SIZE_IN_BYTES: 200 * 1024 * 1024, // 200 MB
    MAX_SIZE_IN_MB: 200,
    ALLOWED_EXTENSIONS: ['mpeg3', 'x-mpeg-3', 'mpeg', 'm4a', 'x-m4a', 'wav', 'x-wav'],
    ALLOWED_EXTENSIONS_TEXT: '.mp3, .wav, .m4a',
    MIN_DURATION_IN_SECONDS: 10,
  },
  MIXED: {
    MAX_SIZE_IN_BYTES: 2048 * 1024 * 1024, // 2 GB
    MAX_SIZE_IN_MB: 2048,
    ALLOWED_EXTENSIONS: ['png', 'jpeg', 'jpg', 'heic', 'mp4', 'x-mp4', 'quicktime'],
    ALLOWED_EXTENSIONS_TEXT: '.png, .jpeg, .jpg, .heic, .mp4, .mov, .MOV',
  },
  VIDEO: {
    MAX_SIZE_IN_BYTES: 2048 * 1024 * 1024, // 2 GB
    MAX_SIZE_IN_MB: 2048,
    ALLOWED_EXTENSIONS: ['mp4', 'x-mp4', 'quicktime', 'mov'],
    ALLOWED_EXTENSIONS_TEXT: '.mp4, .mov, .MOV',
  },
  STORY: {
    MAX_SIZE_IN_BYTES: 30 * 1024 * 1024, // 30 MB
    MAX_SIZE_IN_MB: 30,
    ALLOWED_EXTENSIONS: ['png', 'jpeg', 'jpg', 'heic', 'mp4', 'x-mp4', 'quicktime'],
    ALLOWED_EXTENSIONS_TEXT: '.png, .jpeg, .jpg, .heic, .mp4, .mov, .MOV',
  },
};

export const MIN_NUM_OF_FREE_PHOTOS = 5;
export const MIN_NUM_OF_FREE_VIDEOS = 5;
export const MIN_NUM_OF_PREMIUM_PHOTOS = 50;
export const MIN_NUM_OF_PREMIUM_VIDEOS = 20;
export const MIN_NUM_OF_AUDIOS = 1;

export const ALBUM_MEDIA_TYPE = {
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
};

export const ALBUM_MEDIA_CATEGORY = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
};

export const UPLOAD_MEDIA_FILE_ERROR_TYPE = {
  FILE_SIZE: 'FILE_SIZE',
  FILE_TYPE: 'FILE_TYPE',
  AUDIO_DURATION: 'AUDIO_DURATION',
};

export const USER_ROLE = {
  INFLUENCER: 'INFLUENCER',
  INFLUENCER_REQUEST: 'INFLUENCER_REQUEST',
  AGENCY: 'AGENCY',
  CRM_ORGANIZATION_MEMBER: 'CRM_ORGANIZATION_MEMBER',
};

export const CRM_ORGANIZATION_MEMBER_ROLE = {
  CHATTER: 'Chatter',
  CONTENT_MANAGER: 'ContentManager',
  REVIEWER: 'Reviewer',
  TEAM_LEAD: 'TeamLead',
  ADMINISTRATOR: 'Administrator',
  OWNER: 'Owner',
};

export const CRM_ORGANIZATION_MEMBER_ROLES = Object.values(CRM_ORGANIZATION_MEMBER_ROLE);

export const MESSAGE_FLOW = {
  MANUAL_FLOW: 'MANUAL_FLOW',
  AI_FLOW: 'AI_FLOW',
};

export const MANUAL_FLOW_INSTRUCTION_TYPE = {
  DEFAULT: 'DEFAULT',
  BUILDUP: 'BUILDUP',
  CONVERT: 'CONVERT',
  AFTERCARE: 'AFTERCARE',
};

export const WITHDRAWAL_METHOD_TYPE = {
  DOMESTIC_WIRE: 'DOMESTIC_WIRE',
  INTERNATIONAL_WIRE: 'INTERNATIONAL_WIRE',
  CRYPTO: 'CRYPTO',
};

export const CRYPTO_NETWORK = {
  TRC_20: 'TRC_20',
  ERC_20: 'ERC_20',
  TON: 'TON',
};

export const EARNINGS_TYPE = {
  GROSS: 'GROSS',
  NET: 'NET',
};

export const WITHDRAWAL_METHOD_PROFILE_TYPE = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
};

export const INFLUENCER_PERSONA_STYLE = {
  BRAND_FRIENDLY: 'BRAND_FRIENDLY',
  SEXUAL: 'SEXUAL',
};

export const INFLUENCER_REQUEST_ONBOARDING_TYPE = {
  SELF: 'SELF',
  ASSISTED: 'ASSISTED',
};

export const MEDIA_ASSET_SALE_TAG = {
  SINGLE_PAID: 'SINGLE_PAID',
  SINGLE_FREE: 'SINGLE_FREE',
  BUNDLE: 'BUNDLE',
  UNASSIGNED: 'UNASSIGNED',
  STORY: 'STORY',
};

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

export const MESSAGE_TYPE = {
  MESSAGE: 'MESSAGE',
  OFFER: 'OFFER',
  PURCHASE: 'PURCHASE',
};

export const MESSAGE_TARGET = {
  FREE_PHOTO: 'FREE_PHOTO',
  PREMIUM_PHOTO: 'PREMIUM_PHOTO',
  FREE_VIDEO: 'FREE_VIDEO',
  PREMIUM_VIDEO: 'PREMIUM_VIDEO',
  BUNDLE: 'BUNDLE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  GIFT: 'GIFT',
  NON_SPENDING_COUNTRY_TIP: 'NON_SPENDING_COUNTRY_TIP',
  CUSTOM_VIDEO: 'CUSTOM_VIDEO',
  SWITCH_CONVERSATION_PHASE: 'SWITCH_CONVERSATION_PHASE',
};

export const SOCKET_EVENTS = {
  SWITCH_ROOM: 'SWITCH_ROOM',
  SWITCH_INFLUENCER_ROOM: 'SWITCH_INFLUENCER_ROOM',
  REFRESH_CHAT_LIST: 'REFRESH_CHAT_LIST',
  REFRESH_OPEN_CHAT: 'REFRESH_OPEN_CHAT',
  CONNECTED: 'CONNECTED',
  NOTIFICATION: 'NOTIFICATION',
};

export const CHAT_ACTIVITY_TYPE = {
  MESSAGE: 'MESSAGE',
  OFFER: 'OFFER',
  PURCHASE: 'PURCHASE',
  EVENT: 'EVENT',
};

export const MANUAL_CHAT_SECRET = 'COSMA£££';

export const CHAT_ACTIVITY_TARGET = {
  FREE_PHOTO: 'FREE_PHOTO',
  PREMIUM_PHOTO: 'PREMIUM_PHOTO',
  FREE_VIDEO: 'FREE_VIDEO',
  PREMIUM_VIDEO: 'PREMIUM_VIDEO',
  BUNDLE: 'BUNDLE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  GIFT: 'GIFT',
  CHANNEL_INVITE: 'CHANNEL_INVITE',
  RANK_PROMOTION: 'RANK_PROMOTION',
  APPRECIATION: 'APPRECIATION',
  HATE_SPEECH: 'HATE_SPEECH',
  SWITCH_CONVERSATION_PHASE: 'SWITCH_CONVERSATION_PHASE',
  BOREDOM: 'BOREDOM',
  START_ASKING_FOR_A_COUNTRY: 'START_ASKING_FOR_A_COUNTRY',
  NON_SPENDING_COUNTRY_TIP: 'NON_SPENDING_COUNTRY_TIP',
};
